export default __webpack_public_path__ + "static/picto_pieces-white-4fcd9c0d2cc71b451973028b1a9acbee.png";